export default __webpack_public_path__ + "static/media/01.7ad6e53e.jpg";